/* eslint-disable react-hooks/exhaustive-deps */
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React, { useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import ReactStars from "react-stars";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { getApiCaller } from "../../libs/apiCaller";

const WriteReview = ({
  isOpen,
  onClose,
  detailsInfo,
  fetchCompleteAppoinmentsDetails,
  editReviewDetails,
  setEditReviewDetails,
}) => {
  useEffect(() => {
    if (editReviewDetails) {
      formik.setValues({
        rating: Number(editReviewDetails?.rating),
        review: editReviewDetails?.review,
      });
    }
  }, [editReviewDetails]);

  const formik = useFormik({
    initialValues: {
      review: "",
      rating: 0,
    },
    validationSchema: Yup.object({
      review: Yup.string().required("Feedback is required"),
      rating: Yup.number()
        .min(0.5, "Rating is required")
        .required("Rating is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const endPoint = editReviewDetails?.review_id
          ? `edit_review?review=${values.review}&rating=${values.rating}&review_id=${editReviewDetails?.review_id}`
          : `add_review?review=${values.review}&rating=${values.rating}&provider_id=${detailsInfo?.provider_details?.provider_id}&booking_id=${detailsInfo?.booking_id}`;

        const response = await getApiCaller(endPoint);
        if (response?.data.response_code === 200) {
          toast.success(response.data.response_message);
          fetchCompleteAppoinmentsDetails && fetchCompleteAppoinmentsDetails();
          onClose();
          formik.resetForm();
          setEditReviewDetails({});
        } else {
          toast.error(response?.data?.response_message);
        }
        setSubmitting(false);
      } catch (error) {
        toast.error(error?.message);
        setSubmitting(false);
      }
    },
  });

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        onClose();
        formik.resetForm();
        setEditReviewDetails && setEditReviewDetails({});
      }}
      className="relative z-50"
    >
      <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />

      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-2 sm:p-4">
          <DialogPanel className="relative w-full transform overflow-hidden bg-white text-left shadow-xl transition-all rounded-lg mx-2 sm:mx-0 max-w-[95vw] sm:max-w-md md:max-w-lg">
            <div className="bg-[#21140E0F] px-3 sm:px-4 pb-4 sm:pb-6 pt-2 sm:pt-3">
              {/* Header */}
              <div className="flex justify-between items-center mb-3 sm:mb-4">
                <DialogTitle className="text-lg sm:text-xl font-bold text-[#284184]">
                  {editReviewDetails?.review_id ? "Update" : "Write a"} Review
                </DialogTitle>
                <button
                  onClick={onClose}
                  className="text-gray-600 hover:text-gray-800 p-1"
                >
                  <IoMdClose className="text-2xl font-light" />
                </button>
              </div>

              {/* Profile Section */}
              <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                {/* <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full overflow-hidden bg-gray-100">
                  <img
                    src="https://c8.alamy.com/comp/KEDB24/handsome-young-man-profile-KEDB24.jpg"
                    alt="Profile"
                    className="w-full h-full object-cover"
                  />
                </div> */}
                <div>
                  <h3 className="font-bold text-[#284184] text-sm sm:text-2xl">
                    {detailsInfo?.provider_details?.provider_name}
                  </h3>
                </div>
              </div>

              {/* Question */}
              <p className="text-sm sm:text-xl font-bold text-[#284184] mb-2">
                How was your experience with{" "}
                {detailsInfo?.provider_details?.provider_name}?
              </p>

              {/* Star Rating */}
              <div className="mb-2">
                <ReactStars
                  count={5}
                  onChange={(newRating) =>
                    formik.setFieldValue("rating", newRating)
                  }
                  size={50}
                  color2={"#ffd700"}
                  className="cursor-pointer transition-transform duration-300 -mt-5"
                  value={formik.values.rating}
                />
                {formik.touched.rating && formik.errors.rating && (
                  <p className="text-red-500 text-sm">{formik.errors.rating}</p>
                )}
              </div>

              {/* Form */}
              <form onSubmit={formik.handleSubmit}>
                {/* Feedback Section */}
                <div className="mb-4">
                  <label className="block text-sm sm:text-base font-semibold text-gray-700 mb-1">
                    Feedback <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="review"
                    className={`w-full border ${
                      formik.touched.review && formik.errors.review
                        ? "border-red-500"
                        : "border-gray-300"
                    } rounded-lg p-2 text-sm sm:text-base h-20 sm:h-24 resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    placeholder="Write Something..."
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.review}
                  />
                  {formik.touched.review && formik.errors.review && (
                    <p className="text-red-500 text-sm">
                      {formik.errors.review}
                    </p>
                  )}
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                  <button
                    type="button"
                    onClick={() => {
                      onClose();
                      formik.resetForm();
                      setEditReviewDetails && setEditReviewDetails({});
                    }}
                    className="w-full sm:flex-1 py-2 px-4 border border-[#F04438] rounded-lg text-sm sm:text-xl font-bold text-[#F04438]"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="w-full sm:flex-1 py-2 px-4 bg-[#284184] text-white rounded-lg text-sm sm:text-xl font-bold"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting
                      ? "Loading..."
                      : editReviewDetails?.review_id
                      ? "Update Review"
                      : "Add Review"}
                  </button>
                </div>
              </form>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default WriteReview;
